<template>
  <div>
    <h1 style="color: red; margin-top: 60px">
      Session Expire! Please login again
    </h1>
    <div style="margin-top: 10px; text-align: center">
      <img
        src="../assets/images/payerror.gif"
        style="height: 10%; width: 10%"
      />
    </div>
    <div>
      <input
        class="LoginBlock"
        type="button"
        value="Login Again"
        style="margin-top: 30px"
        v-on:click="redirectLogin"
      />
    </div>
  </div>
</template>
<style scoped>
div {
  background-color: white;
  color: black;
  text-align: center;
  width: 100%;
}
.LoginBlock {
  border: solid 2px #05a9f8;
  border-radius: 6px;
  -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%) inset,
    0 1px 0 0 rgb(250 250 250 / 50%);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%) inset,
    0 1px 0 0 rgb(250 250 250 / 50%);
  padding: 6px 40px 6px 40px;
  -webkit-transition: all 0.2s linear 0s;
  transition: all 0.2s linear 0s;
  background-color: #05a9f8;
  color: white;
  font-size: 12pt;
}
</style>
<script>
import vue from "vue";
import router from "vue-router";
export default {
  name: "SessionExpire",
  components: {},
  data() {
    return {};
  },
  methods: {
    redirectLogin() {
      // this.$router.push({ name: "Login" });
      // window.sessionStorage.clear();
      this.$root.$data.sessionPage = 1;
      this.$router.push("/");
      // window.location.href = "/#/";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SessionExpire.vue